export const initialState = {
	dialogs: {
		deleteConfirm: false,
		addConfirm: false,
		editConfirm: false,
		makeLegitConfirm: false,
		selectedRecord: null,
	},
	forms: {
		addContactForm: {
			firstName: "",
			lastName: "",
			email: "",
			mobileNumber: "",
			idType: "",
			idNumber: "",
		},
		editContactForm: {
			firstName: "",
			lastName: "",
			email: "",
			mobile_number: "",
			id_type: "",
			id_number: "",
		},
		initialEditContactForm: {
			firstName: "",
			lastName: "",
			email: "",
			mobile_number: "",
			id_type: "",
			id_number: "",
		},
		makeLegitFormData: {
			Roles: [],
		},
	},
	ui: {
		roleOptions: [],
	},
	loading: {
		isLoadingBackdrop: false,
		isBackgroundRefreshing: false,
	},
	table: {
		searchInput: "",
		currentPage: 1,
		recordsPerPage: 10,
	},
};

export function manageCompanyContactsReducer(state, action) {
	switch (action.type) {
		case "OPEN_DELETE_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					deleteConfirm: true,
					selectedRecord: action.payload,
				},
			};
		case "CLOSE_DELETE_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					deleteConfirm: false,
					selectedRecord: null,
				},
			};
		case "OPEN_EDIT_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					editConfirm: true,
					selectedRecord: action.payload.record,
				},
				forms: {
					...state.forms,
					editContactForm: action.payload.editFormData,
					initialEditContactForm: action.payload.editFormData,
				},
			};
		case "CLOSE_EDIT_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					editConfirm: false,
					selectedRecord: null,
				},
				forms: {
					...state.forms,
					editContactForm: initialState.forms.editContactForm,
					initialEditContactForm: initialState.forms.initialEditContactForm,
				},
			};
		case "OPEN_ADD_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					addConfirm: true,
				},
			};
		case "CLOSE_ADD_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					addConfirm: false,
				},
				forms: {
					...state.forms,
					addContactForm: initialState.forms.addContactForm,
				},
			};
		case "OPEN_MAKE_LEGIT_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					makeLegitConfirm: true,
					selectedRecord: action.payload.record,
				},
				ui: {
					...state.ui,
					roleOptions: action.payload.roleOptions,
				},
			};
		case "CLOSE_MAKE_LEGIT_DIALOG":
			return {
				...state,
				dialogs: {
					...state.dialogs,
					makeLegitConfirm: false,
					selectedRecord: null,
				},
				forms: {
					...state.forms,
					makeLegitFormData: initialState.forms.makeLegitFormData,
				},
			};
		case "UPDATE_FORM_FIELD":
			return {
				...state,
				forms: {
					...state.forms,
					[action.payload.formName]: {
						...state.forms[action.payload.formName],
						[action.payload.fieldName]: action.payload.value,
					},
				},
			};
		case "SET_LOADING":
			return {
				...state,
				loading: {
					...state.loading,
					[action.payload.key]: action.payload.value,
				},
			};
		case "SET_SEARCH_INPUT":
			return {
				...state,
				table: { ...state.table, searchInput: action.payload, currentPage: 1 },
			};
		case "SET_CURRENT_PAGE":
			return {
				...state,
				table: { ...state.table, currentPage: action.payload },
			};
		default:
			return state;
	}
}
